import React from 'react'
import Footer from '../Components/Footer'
import Header from '../Components/Header'

function Swapping() {
  return (
    <>
       <Header/>
      <div class="container mt-5">
      <div class="row justify-content-center">
          <div class="crypt-login-form mt-5 swap-card">
              <div class="d-flex justify-content-between mb-4 text-center">
                  <h3 class="fw-bold">Trade</h3>
                 
              </div>

              <div class="tab-content table-responsive justify-content-between mb-0 p-0">
                  <div class="d-flex flex-row nav nav-pills nav-justified card-bs-tabs p-1">
                      <button class="nav-link active fs-6" id="buy-tab" data-bs-toggle="tab" data-bs-target="#buy-tab-pane" type="button" aria-controls="buy-tab-pane">Swap</button>
                      <button class="nav-link fs-6" id="sell-tab" data-bs-toggle="tab" data-bs-target="#sell-tab-pane" type="button" aria-controls="sell-tab-pane">Twap</button>
                      <button class="nav-link fs-6" id="limit-tab" data-bs-toggle="tab" data-bs-target="#Limit-tab-pane" type="button" aria-controls="Limit">Limit</button>
                  </div>
               
                  <div class="tab-pane fade show active pt-4" id="buy-tab-pane" role="tabpanel" aria-labelledby="buy-tab" tabindex="0">
                      <div class="swap-box">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label  text-light mb-0">From</label>

                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="text" class="form-control form-swap px-0" placeholder="0.0"/>
                              <div class="input-group-append input-group-text p-1">

                                  <button class="swap-select " data-bs-toggle="modal" data-bs-target="#buyCrypto" type="button">
                                      <span class="swap-icon"><img  alt="" src="https://icons.de.fi/binancecoin/coingecko.webp" /></span> <span class="text-sm">BNB</span>
                                      <span class="Swap-moreicon"><i class="fi fi-rr-caret-down"></i></span>

                                  </button>
                              </div>

                          </div>
                          <div class="mt-0 text-sm p-1 pt-0">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0 lineh">≈ $2050.24</p>
                                  <p class="crypt-grayscale-500 fw-bold mb-0 lineh">Balance : 0.00</p>
                              </div>

                          </div>
                      </div>

                      <div class="text-center">
                          <button class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium reverseBtn Swapbutton" tabindex="0" type="button" styling="borderless" height="large" data-testid="swap__reverse-button">
                              <i class="fi fi-rr-sort-alt"></i>
                          </button>
                      </div>


                      <div class="swap-box">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label  text-light mb-0">To</label>

                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="text" class="form-control form-swap px-0" placeholder="0.0"/>
                              <div class="input-group-append input-group-text p-1">

                                  <button class="swap-select " data-bs-toggle="modal" data-bs-target="#buyCrypto" type="button">
                                      <span class="swap-icon"><img  alt="" src="https://icons.de.fi/pepe/coingecko.webp" /></span> <span class="text-sm">PEPE</span>
                                      <span class="Swap-moreicon"><i class="fi fi-rr-caret-down"></i></span>

                                  </button>
                              </div>

                          </div>
                          <div class="mt-0 text-sm p-1 pt-0">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0 lineh">≈ $0.0</p>
                                  <p class="crypt-grayscale-500 fw-bold mb-0 lineh">Balance : 0.00</p>
                              </div>

                          </div>
                      </div>

                      <div class="mt-2 text-sm  p-1">

                          <div class="d-flex flex-row justify-content-between">
                              <p class="crypt-grayscale-500 mb-0">Gas Fee:</p>
                              <p class="text-primary mb-0">
                                  Fast ≈ 0.00001 BNB / $0.01
                              </p>
                          </div>
                          <div class="d-flex flex-row justify-content-between">
                              <p class="crypt-grayscale-500 mb-1">Rate:</p>
                              <p class="crypt-grayscale-300 mb-1">1 USDT ≈ 100471.35045 PEPE</p>
                          </div>
                      </div>

                      <div class="d-grid">
                          <a class="btn btn-primary text-white py-2" href="#" role="button">Connect Wallet </a>
                      </div>

                  </div>
                
                  <div class="tab-pane fade pt-4" id="sell-tab-pane" role="tabpanel" aria-labelledby="sell-tab" tabindex="0">
                      <div class="swap-box">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label  text-light mb-0">From</label>

                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="text" class="form-control form-swap px-0" placeholder="0.0"/>
                              <div class="input-group-append input-group-text p-1">

                                  <button class="swap-select " data-bs-toggle="modal" data-bs-target="#buyCrypto" type="button">
                                      <span class="swap-icon"><img  alt="" src="https://icons.de.fi/binancecoin/coingecko.webp" /></span> <span class="text-sm">BNB</span>
                                      <span class="Swap-moreicon"><i class="fi fi-rr-caret-down"></i></span>

                                  </button>
                              </div>

                          </div>
                          <div class="mt-0 text-sm p-1 pt-0">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0">≈ $2050.24</p>
                                  <p class="crypt-grayscale-500 fw-bold mb-0">Balance : 0.00</p>
                              </div>

                          </div>
                      </div>

                      <div class="text-center">
                          <button class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium reverseBtn Swapbutton" tabindex="0" type="button" styling="borderless" height="large" data-testid="swap__reverse-button">
                              <i class="fi fi-rr-sort-alt"></i>
                          </button>
                      </div>


                      <div class="swap-box">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label  text-light mb-0">To</label>

                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="text" class="form-control form-swap px-0" placeholder="0.0"/>
                              <div class="input-group-append input-group-text p-1">

                                  <button class="swap-select " data-bs-toggle="modal" data-bs-target="#buyCrypto" type="button">
                                      <span class="swap-icon"><img  alt="" src="https://icons.de.fi/pepe/coingecko.webp" /></span> <span class="text-sm">PEPE</span>
                                      <span class="Swap-moreicon"><i class="fi fi-rr-caret-down"></i></span>

                                  </button>
                              </div>

                          </div>
                          <div class="mt-0 text-sm p-1 pt-0">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0">≈ $0.0</p>
                                  <p class="crypt-grayscale-500 fw-bold mb-0">Balance : 0.00</p>
                              </div>

                          </div>
                      </div>

                      <div class="mt-2 text-sm  p-1">

                          <div class="d-flex flex-row justify-content-between">
                              <p class="crypt-grayscale-500 mb-0">Gas Fee:</p>
                              <p class="text-primary mb-0">Free</p>
                          </div>
                          <div class="d-flex flex-row justify-content-between">
                              <p class="crypt-grayscale-500 mb-1">Rate:</p>
                              <p class="crypt-grayscale-600 mb-1">1 USDT ≈ 100471.35045 PEPE</p>
                          </div>
                      </div>

                      <div class="d-grid">
                          <a class="btn btn-primary text-white py-2" href="#" role="button">Connect Wallet </a>
                      </div>

                  </div>

                  <div class="tab-pane fade pt-4" id="Limit-tab-pane" role="tabpanel" aria-labelledby="limit-tab" tabindex="0">
                      <div class="swap-box">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label  text-light mb-0">From</label>

                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="text" class="form-control form-swap px-0" placeholder="0.0"/>
                              <div class="input-group-append input-group-text p-1">

                                  <button class="swap-select " data-bs-toggle="modal" data-bs-target="#buyCrypto" type="button">
                                      <span class="swap-icon"><img  alt="" src="https://icons.de.fi/binancecoin/coingecko.webp" /></span> <span class="text-sm">BNB</span>
                                      <span class="Swap-moreicon"><i class="fi fi-rr-caret-down"></i></span>

                                  </button>
                              </div>

                          </div>
                          <div class="mt-0 text-sm p-1 pt-0">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0">≈ $2050.24</p>
                                  <p class="crypt-grayscale-500 fw-bold mb-0">Balance : 0.00</p>
                              </div>

                          </div>
                      </div>

                      <div class="text-center">
                          <button class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium reverseBtn Swapbutton" tabindex="0" type="button" styling="borderless" height="large" data-testid="swap__reverse-button">
                              <i class="fi fi-rr-sort-alt"></i>
                          </button>
                      </div>


                      <div class="swap-box">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label  text-light mb-0">To</label>

                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="text" class="form-control form-swap px-0" placeholder="0.0"/>
                              <div class="input-group-append input-group-text p-1">

                                  <button class="swap-select " data-bs-toggle="modal" data-bs-target="#buyCrypto" type="button">
                                      <span class="swap-icon"><img  alt="" src="https://icons.de.fi/pepe/coingecko.webp" /></span> <span class="text-sm">PEPE</span>
                                      <span class="Swap-moreicon"><i class="fi fi-rr-caret-down"></i></span>

                                  </button>
                              </div>

                          </div>
                          <div class="mt-0 text-sm p-1 pt-0">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0">≈ $0.0</p>
                                  <p class="crypt-grayscale-500 fw-bold mb-0">Balance : 0.00</p>
                              </div>

                          </div>
                      </div>

                      <div class="mt-2 text-sm  p-1">

                          <div class="d-flex flex-row justify-content-between">
                              <p class="crypt-grayscale-500 mb-0">Gas Fee:</p>
                              <p class="text-primary mb-0">
                                  Fast ≈ 0.00001 BNB / $0.01
                              </p>
                          </div>
                          <div class="d-flex flex-row justify-content-between">
                              <p class="crypt-grayscale-500 mb-1">Rate:</p>
                              <p class="crypt-grayscale-600 mb-1">1 USDT ≈ 100471.35045 PEPE</p>
                          </div>
                      </div>

                      <div class="d-grid">
                          <a class="btn btn-primary text-white py-2" href="#" role="button">Connect Wallet </a>
                      </div>

                  </div>


              </div>

             
             
          </div>
      </div>
  </div>

<Footer/>



  <div class="modal fade" id="buyCrypto" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header d-flex">
                  <h5 class="d-flex align-items-center gap-3 crypt-grayscale-100 mb-0">From</h5>
                  <button type="button" class="btn-close text-reset close-notify align-items-center justify-content-center" data-bs-dismiss="modal" aria-label="Close">
                      <svg class="close-notify" width="18" height="18" viewbox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.5 4.5L4.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                  </button>
              </div>
              <div class="modal-body">

                  <div class="input-group mb-3 P-1">

                      <input class="form-control placeholder-text" type="text" placeholder="search by name or address"/>
                      <div class="input-group-append input-group-text p-1">

                      </div>
                  </div>

                  <div class="input-group text-sm mb-3 P-1">
                      Network : BNB Chain

                  </div>

                  <div class="input-group text-sm mb-3 P-1">
                      Popular Tokens

                  </div>



                 
                  <div class="tab-content table-responsive justify-content-between mb-4 p-0">

                   
                      <div class="tab-pane fade show active pt-4" id="buy-tab-pane" role="tabpanel" aria-labelledby="buy-tab" tabindex="0">
                          <div class="input-group mb-3 P-1">
                              <div class="input-group-prepend input-group-text">Spend ≈</div>
                              <input class="form-control placeholder-text" type="text" placeholder="Enter amount"/>
                              <div class="input-group-append input-group-text p-1">
                                  <select class="form-select text-sm crypt-grayscale-500">
                                      <option selected="">USD</option>
                                      <option value="1">AED</option>
                                      <option value="2">AMD</option>
                                      <option value="3">AUD</option>
                                  </select>
                              </div>
                          </div>
                          <div class="input-group mb-3 p-1">
                              <div class="input-group-prepend input-group-text">Receive</div>
                              <input class="form-control placeholder-text" type="text" placeholder="0"/>
                              <div class="input-group-append input-group-text p-1">
                                  <select class="form-select text-sm crypt-grayscale-500">
                                      <option selected="">USDT</option>
                                      <option value="1">BTC</option>
                                      <option value="2">BNB</option>
                                      <option value="3">ETH</option>
                                  </select>
                              </div>
                          </div>
                       
                          <div class="mt-4 mb-4 text-sm">
                              <div class="d-flex flex-row">
                                  <label class="form-label text-light">Payment Method</label>
                              </div>
                              <a class="btn btn-editor btn-outline-primary d-flex flex-row align-items-center justify-content-between card-border p-2" href="#!" data-bs-toggle="" data-bs-target="">
                                  <div class="d-flex flex-row align-items-center crypt-grayscale-300 gap-2">
                                      <svg width="24" height="24" viewbox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M5 15C4.06 15 3.19 15.33 2.5 15.88C1.58 16.61 1 17.74 1 19C1 19.75 1.21 20.46 1.58 21.06C2.27 22.22 3.54 23 5 23C6.01 23 6.93001 22.63 7.63 22C7.94 21.74 8.21 21.42 8.42 21.06C8.79 20.46 9 19.75 9 19C9 16.79 7.21 15 5 15ZM7.07001 18.57L4.94 20.54C4.8 20.67 4.60999 20.74 4.42999 20.74C4.23999 20.74 4.04999 20.67 3.89999 20.52L2.91 19.53C2.62 19.24 2.62 18.76 2.91 18.47C3.2 18.18 3.68 18.18 3.97 18.47L4.45 18.95L6.05 17.47C6.35 17.19 6.83 17.21 7.11 17.51C7.39 17.81 7.37001 18.29 7.07001 18.57Z" fill="currentColor"></path>
                                          <path opacity="0.4" d="M19.48 12.95H21.5V11.51C21.5 9.44001 19.81 7.75 17.74 7.75H6.25999C4.18999 7.75 2.5 9.44001 2.5 11.51V15.88C3.19 15.33 4.06 15 5 15C7.21 15 9 16.79 9 19C9 19.75 8.79 20.46 8.42 21.06C8.21 21.42 7.94 21.74 7.63 22H17.74C19.81 22 21.5 20.31 21.5 18.24V17.05H19.6C18.52 17.05 17.53 16.26 17.44 15.18C17.38 14.55 17.62 13.96 18.04 13.55C18.41 13.17 18.92 12.95 19.48 12.95Z" fill="currentColor"></path>
                                          <path d="M14.85 3.95012V7.75011H6.25999C4.18999 7.75011 2.5 9.44012 2.5 11.5101V7.84014C2.5 6.65014 3.23 5.59009 4.34 5.17009L12.28 2.17009C13.52 1.71009 14.85 2.62012 14.85 3.95012Z" fill="currentColor"></path>
                                          <path d="M22.5598 13.9702V16.0302C22.5598 16.5802 22.1198 17.0302 21.5598 17.0502H19.5998C18.5198 17.0502 17.5298 16.2602 17.4398 15.1802C17.3798 14.5502 17.6198 13.9602 18.0398 13.5502C18.4098 13.1702 18.9198 12.9502 19.4798 12.9502H21.5598C22.1198 12.9702 22.5598 13.4202 22.5598 13.9702Z" fill="currentColor"></path>
                                          <path d="M14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z" fill="currentColor"></path>
                                      </svg>
                                     BNB
                                      <svg width="50" height="17" viewbox="0 0 50 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9289 16.0671L19.5488 0.834256H23.6709L19.0508 16.0671H14.9289ZM13.0862 0.838415L9.37817 7.29564C8.43424 8.98682 7.88249 9.84103 7.61717 10.9098H7.56072C7.62638 9.55491 7.43741 7.89165 7.41959 6.95158L7.01016 0.838415H0.0713081L0 1.24814C1.7827 1.24814 2.83984 2.14365 3.13071 3.97537L4.48319 16.0671H8.75364L17.3884 0.838415H13.0862ZM45.1423 16.0671L45.0285 13.8016L39.8813 13.7974L38.8286 16.0668H34.3535L42.468 0.863076H47.9611L49.3353 16.0668H45.1423V16.0671ZM44.6696 7.08172C44.6239 5.95594 44.5856 4.42787 44.6622 3.50325H44.6013C44.3505 4.25941 43.2729 6.53027 42.799 7.64713L41.2653 10.9861H44.8794L44.6696 7.08172ZM27.9984 16.5C25.0882 16.5 23.1569 15.5769 21.778 14.7538L23.7417 11.7551C24.9794 12.4473 25.9513 13.2463 28.1874 13.2463C28.9064 13.2463 29.5993 13.0594 29.9927 12.3781C30.5661 11.3872 29.8605 10.8542 28.2501 9.94265L27.455 9.42567C25.068 7.7945 24.0355 6.24533 25.1592 3.54098C25.8782 1.81117 27.7747 0.5 30.9034 0.5C33.061 0.5 35.0838 1.43324 36.2624 2.34509L34.0049 4.99269C32.8548 4.06242 31.9014 3.59179 30.8104 3.59179C29.9404 3.59179 29.2796 3.92723 29.0514 4.37974C28.6221 5.23039 29.1902 5.81036 30.4446 6.5891L31.39 7.19046C34.2881 9.01832 34.9786 10.935 34.2522 12.7269C33.0031 15.8113 30.5572 16.5 27.9984 16.5Z" fill="#1434CB"></path>
                                      </svg>
                                      <svg width="30" height="19" viewbox="0 0 30 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M18.8324 16.5755H10.9585V2.42493H18.8325L18.8324 16.5755Z" fill="#FF5F00"></path>
                                          <path d="M11.4577 9.49945C11.4577 6.62901 12.8017 4.07201 14.8946 2.42417C13.3104 1.175 11.3509 0.497029 9.33348 0.50001C4.36375 0.50001 0.335205 4.52914 0.335205 9.49945C0.335205 14.4698 4.36375 18.4989 9.33348 18.4989C11.351 18.5019 13.3105 17.8239 14.8947 16.5747C12.802 14.9272 11.4577 12.37 11.4577 9.49945Z" fill="#EB001B"></path>
                                          <path d="M29.4553 9.50067C29.4553 14.471 25.4268 18.5001 20.457 18.5001C18.4393 18.5031 16.4796 17.8251 14.895 16.576C16.9885 14.9281 18.3325 12.3713 18.3325 9.50067C18.3325 6.63009 16.9885 4.07323 14.895 2.42539C16.4795 1.17625 18.4392 0.498302 20.4569 0.50123C25.4266 0.50123 29.4552 4.53036 29.4552 9.50067" fill="#F79E1B"></path>
                                      </svg>
                                  </div>
                                  <svg width="18" height="18" viewbox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.75 13.5L11.25 9L6.75 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                  </svg>
                              </a>
                          </div>
                          <div class="d-flex flex-row justify-content-between text-sm">
                              <p class="crypt-grayscale-500">Reference Price</p>
                              <p class="crypt-grayscale-300">1 USDT ≈ 1.05 USD</p>
                          </div>
                          
                      </div>
                
                      <div class="tab-pane fade pt-4" id="sell-tab-pane" role="tabpanel" aria-labelledby="sell-tab" tabindex="0">
                          <div class="d-flex flex-row align-items-center justify-content-between px-1">
                              <label class="form-label text-sm text-light">I Want to Sell</label>
                              <label class="form-label text-sm crypt-grayscale-600">
                                  Funding Balance:
                                  <span class="crypt-grayscale-300">0.00 USDT</span>
                              </label>
                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="email" class="form-control text-sm" placeholder="Enter amount"/>
                              <div class="input-group-append input-group-text p-1">
                                  <select class="form-select text-sm crypt-grayscale-500">
                                      <option selected="">USDT</option>
                                      <option value="1">BTC</option>
                                      <option value="2">BNB</option>
                                      <option value="3">ETH</option>
                                  </select>
                              </div>
                          </div>
                          <div class="d-flex flex-row mt-4">
                              <label class="form-label text-sm text-light px-1">I Will Receive</label>
                          </div>
                          <div class="input-group d-flex p-1">
                              <input type="email" class="form-control text-sm" placeholder="0"/>
                              <div class="input-group-append input-group-text p-1">
                                  <select class="form-select text-sm crypt-grayscale-500">
                                      <option selected="">USD</option>
                                      <option value="1">AMD</option>
                                      <option value="2">AFN</option>
                                      <option value="3">AUD</option>
                                  </select>
                              </div>
                          </div>
                          <div class="mt-4 text-sm card-border p-2">
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500">Subtotal:</p>
                                  <p class="crypt-grayscale-600">0.00 USDT</p>
                              </div>
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500">Gas Fee:</p>
                                  <p class="text-primary">Free</p>
                              </div>
                              <div class="d-flex flex-row justify-content-between">
                                  <p class="crypt-grayscale-500 mb-0">Total:</p>
                                  <p class="crypt-grayscale-600 mb-0">0.00 USDT</p>
                              </div>
                          </div>
                          <div class="mt-4 mb-4 text-sm">
                              <div class="d-flex flex-row">
                                  <label class="form-label text-light">Receive Method</label>
                              </div>
                              <a class="btn btn-editor btn-secondary d-flex flex-row align-items-center justify-content-between card-border p-2" href="#!" data-bs-toggle="" data-bs-target="">
                                  <div class="crypt-grayscale-300">
                                      <svg width="24" height="24" viewbox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M5 15C4.06 15 3.19 15.33 2.5 15.88C1.58 16.61 1 17.74 1 19C1 19.75 1.21 20.46 1.58 21.06C2.27 22.22 3.54 23 5 23C6.01 23 6.93001 22.63 7.63 22C7.94 21.74 8.21 21.42 8.42 21.06C8.79 20.46 9 19.75 9 19C9 16.79 7.21 15 5 15ZM7.07001 18.57L4.94 20.54C4.8 20.67 4.60999 20.74 4.42999 20.74C4.23999 20.74 4.04999 20.67 3.89999 20.52L2.91 19.53C2.62 19.24 2.62 18.76 2.91 18.47C3.2 18.18 3.68 18.18 3.97 18.47L4.45 18.95L6.05 17.47C6.35 17.19 6.83 17.21 7.11 17.51C7.39 17.81 7.37001 18.29 7.07001 18.57Z" fill="currentColor"></path>
                                          <path opacity="0.4" d="M19.48 12.95H21.5V11.51C21.5 9.44001 19.81 7.75 17.74 7.75H6.25999C4.18999 7.75 2.5 9.44001 2.5 11.51V15.88C3.19 15.33 4.06 15 5 15C7.21 15 9 16.79 9 19C9 19.75 8.79 20.46 8.42 21.06C8.21 21.42 7.94 21.74 7.63 22H17.74C19.81 22 21.5 20.31 21.5 18.24V17.05H19.6C18.52 17.05 17.53 16.26 17.44 15.18C17.38 14.55 17.62 13.96 18.04 13.55C18.41 13.17 18.92 12.95 19.48 12.95Z" fill="currentColor"></path>
                                          <path d="M14.85 3.95012V7.75011H6.25999C4.18999 7.75011 2.5 9.44012 2.5 11.5101V7.84014C2.5 6.65014 3.23 5.59009 4.34 5.17009L12.28 2.17009C13.52 1.71009 14.85 2.62012 14.85 3.95012Z" fill="currentColor"></path>
                                          <path d="M22.5598 13.9702V16.0302C22.5598 16.5802 22.1198 17.0302 21.5598 17.0502H19.5998C18.5198 17.0502 17.5298 16.2602 17.4398 15.1802C17.3798 14.5502 17.6198 13.9602 18.0398 13.5502C18.4098 13.1702 18.9198 12.9502 19.4798 12.9502H21.5598C22.1198 12.9702 22.5598 13.4202 22.5598 13.9702Z" fill="currentColor"></path>
                                          <path d="M14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z" fill="currentColor"></path>
                                      </svg>
                                      Enter Amount and select payment
                                  </div>
                                  <svg width="18" height="18" viewbox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.75 13.5L11.25 9L6.75 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                  </svg>
                              </a>
                          </div>
                          <div class="d-grid">
                              <a class="btn btn-down" href="#" role="button">Sell USDT</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
    </>
  )
}

export default Swapping